import { render } from "./DeleteShoppingList.vue?vue&type=template&id=0bc95da0&ts=true"
import script from "./DeleteShoppingList.vue?vue&type=script&lang=ts"
export * from "./DeleteShoppingList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/tobias/Projects/MontyBuy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__